<app-dialog-base [Title]='"Shift"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="inputgroup">
    <label>{{'Name'|translate}}</label>
    <input type="text" placeholder="{{'Name'|translate}}" [(ngModel)]="model.Name"/>
  </div>
  <div class="inputgroup">
    <label>{{'Shift start'|translate}}</label>
    <input type="time" placeholder="{{'Shift start'|translate}}" [(ngModel)]="model.StartTime" step="60" min="00:00" max="23:59"/>
  </div>
  <div class="inputgroup">
    <label>{{'Shift end'|translate}}</label>
    <input type="time" placeholder="{{'Shift end'|translate}}" [(ngModel)]="model.EndTime" step="60" min="00:00" max="23:59"/>
  </div>
  <div class="inputgroup">
    <label>{{'Work days'|translate}}</label>
    <div class="workdays">
      <app-week-day-selector [(mask)]="model.Mask"></app-week-day-selector>
    </div>
  </div>
</app-dialog-base>
